import { styled } from "@mui/material/styles";
import { Icons } from "Components/AppGrid/shipeezi-new-grid";
import { IconType } from "react-icons/lib";

import { Button } from "../../../../../../../../../components/Form";

export const Wrapper = styled("div")(() => ({
  width: "100%",
}));

export const Header = styled("header")(() => ({
  display: "flex",
  alignItems: "flex-start",
  alignSelf: "stretch",
  paddingBottom: 20,
  borderBottom: "1px solid #E4E7EC",
  "& > div": {
    width: 220,
    height: 64,
  },
}));

export const Main = styled("main")(() => ({
  paddingTop: 20,
}));

export const Icon = (icon: IconType) =>
  styled(icon)(() => ({
    cursor: "pointer",
  }));

export const ChangeStatusButton = styled(Button)(() => ({
  whiteSpace: "nowrap",
  "& span > div": {
    display: "flex",
    alignItems: "center",
  },
}));

interface BadgeStatusProps {
  isActive: boolean;
}

export const BadgeStatus = styled("div", {
  shouldForwardProp: (prop) => prop !== "isActive",
})<BadgeStatusProps>(({ isActive }) => ({
  backgroundColor: isActive ? "#DCFBEA !important" : "#FEF3F2 !important",
  color: isActive ? "#249F5D" : "#D92D20",
  borderRadius: "20px",
  padding: "6px 10px",
  fontFamily: "Inter",
  fontWeight: 600,
  fontSize: "10px",
  lineHeight: "20px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const IconStatus = styled(Icons.status)(() => ({
  cursor: "pointer",
}));
